import { InferType, object, string } from 'yup';

import { MAX_PHONE_LENGTH } from '@/shared/config';

export const getFullAccessFormSchema = object({
  phoneNumber: string().optional().max(MAX_PHONE_LENGTH),
});

export type GetFullAccessFormPayload = InferType<
  typeof getFullAccessFormSchema
>;
